import {NetworkIds} from 'bitcannery-core'

export default {
  [NetworkIds.Mainnet]: 'Main',
  [NetworkIds.Morden]: 'Morden',
  [NetworkIds.Ropsten]: 'Ropsten',
  [NetworkIds.Rinkeby]: 'Rinkeby',
  [NetworkIds.Kovan]: 'Kovan',
}
